import { render, staticRenderFns } from "./FormConfigureStock.vue?vue&type=template&id=4ef56f48&"
import script from "./FormConfigureStock.vue?vue&type=script&lang=js&"
export * from "./FormConfigureStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports